import {
    IAtendimentosVistoria,
    IFiltroAtendimentosVistorias,
} from "../../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarAtendimentosVistoriasService(
    pagina: number,
    SEG_ATENDIMENTOS: "GERAL" | "USUARIO" | "GRUPO" | "ACOMPANHAMENTO",
    filtro: IFiltroAtendimentosVistorias,
    todos?: boolean
) {
    return Service(
        Axios.post<IAtendimentosVistoria>(
            `/vistoria/casovistoria/listaratendimentosvistorias?ID_PAGINA=${pagina}&SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}&todos=${
                todos ?? false
            }`,
            filtro
        )
    );
}
